const INITIAL_STATE = {
   ask: false,
   play: false
}

export default function playWelcomeTourReducer(
   state = INITIAL_STATE,
   { type }
) {
   switch (type) {
      case 'ASK_WELCOME_TOUR':
         return {
            ...state,
            ask: true
         }
      case 'DONT_ASK_WELCOME_TOUR':
         return {
            ...state,
            ask: false
         }
      case 'PLAY_WELCOME_TOUR':
         return {
            ...state,
            play: true
         }
      case 'DONT_PLAY_WELCOME_TOUR':
         return {
            ...state,
            play: false
         }
      default:
         return state
   }
}
